import { useDispatch, useSelector } from 'react-redux';
import { selectMessage } from '@store/partners-order/selectors';
import { setMessage } from '@store/partners-order/slice';
import TextArea from '@components/text-field/TextArea';



const Message = (): JSX.Element => {

	const message = useSelector(selectMessage);
	const dispatch = useDispatch();
	const updateMessage = (value: string | null) => dispatch(setMessage(value));

	return (
		<div className='message-section'>

			<TextArea
				label='Vaše zpráva (volitelné)'
				rounded={true}
				maxLength={250}
				value={message ? message : undefined}
				onChange={(value: string) => !value && value.length === 0 ? updateMessage(null) : updateMessage(value)} />

		</div>
	);
};

export default Message;